import React from 'react';
import { Global, css } from '@emotion/core';

import 'normalize.css';

const createBaseStyles = (theme) => css`
  @font-face {
    font-family: 'Brewed-Regular';
    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Regular.otf')
      format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brewed-Light';
    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Light.otf')
      format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brewed-Bold';
    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Bold.otf')
      format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'grease_pencil';
    src: url('https://timhortons.sfo2.digitaloceanspaces.com/crm/GreasePencil.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    font-family: ${theme.fontStack.default.name};
    font-weight: ${theme.fontStack.default.weight};
    letter-spacing: 0.3px;
    font-size: 14px;
    font-weight: 300;
    line-height: 1.4;
    margin: 0;
    padding: 0;
    -webkit-text-size-adjust: 100%;
  }

  sup {
    font-size: 7px;
    top: -1em;
  }
`;

const BaseStyles = () => <Global styles={(theme) => createBaseStyles(theme)} />;

BaseStyles.propTypes = {};

BaseStyles.defaultProps = {
  custom: '',
};

export default BaseStyles;
